module.exports = __webpack_public_path__ + "static/img/card_bg.2cef446d.png";